module.exports = __webpack_public_path__ + "static/media/CloseButton@3x.c4173019.png";